import { useEffect } from "react";
import { useChatDrawerButtonUtils } from "./useChatDrawerButtonUtils";
import { setFaviconAndTitleBasedOnUnreadMessagesCount } from "./utils";
import { useAtomValue } from "jotai";
import { VisitorDrawerState, visitorDrawerStateAtom } from "../state";
import { ChatDrawerControlButton } from "../../session/controls/ChatDrawerControl";
import { useTranslate } from "@growtherapy/i18n";

export function ChatDrawerButtonWrapper({
  drawerId,
  onOpen,
  onClose,
  defaultTitle,
}: {
  drawerId: string;
  onOpen?: () => void;
  onClose?: () => void;
  defaultTitle?: string;
}) {
  const t = useTranslate();
  const { unreadMessagesCount, toggleChatDrawer, isChatDrawerDisabled } =
    useChatDrawerButtonUtils({ onOpen, onClose });
  const drawerState = useAtomValue(visitorDrawerStateAtom);

  useEffect(
    function showUnreadChatNotificationInFaviconAndTitle() {
      // Provider no show title takes priority over chat notifications
      if (document.title === t("telehealth-core:meta.providerNotHere")) return;
      setFaviconAndTitleBasedOnUnreadMessagesCount(
        unreadMessagesCount,
        defaultTitle ?? t("telehealth-core:meta.growTherapyTelehealth"),
      );
    },
    [t, defaultTitle, unreadMessagesCount],
  );

  return (
    <ChatDrawerControlButton
      drawerId={drawerId}
      forDrawerStates={VisitorDrawerState.CHAT}
      isChatDrawerOpen={drawerState === VisitorDrawerState.CHAT}
      onClick={toggleChatDrawer}
      disabled={isChatDrawerDisabled}
      messageCount={unreadMessagesCount}
    />
  );
}
